import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#e3e3e3",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M480-120v-80h280v-560H480v-80h280q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H480Zm-80-160-55-58 102-102H120v-80h327L345-622l55-58 200 200-200 200Z" })
});
export default SvgLogin;
